"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcaLegacySwap = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const BufferLayout = __importStar(require("@solana/buffer-layout"));
const sdk_1 = require("@orca-so/sdk");
const pools_1 = require("@orca-so/sdk/dist/constants/pools");
const config_1 = require("@orca-so/sdk/dist/public/devnet/pools/config");
const pools_2 = require("@orca-so/sdk/dist/constants/devnet/pools");
class OrcaLegacySwap {
    constructor(accounts) {
        this.accounts = accounts;
    }
    static load(tokenA, tokenB, cluster) {
        const tokenPairSig = tokenA.toString() + tokenB.toString();
        let tokenPairToOrcaLegacyPool;
        // Load orca pool parameters from the sdk for look-up.
        // Because the sdk doesn't support look-up using token mint pubkeys.
        if (cluster == "devnet") {
            tokenPairToOrcaLegacyPool = Object.fromEntries(Object.values(config_1.OrcaPoolConfig).map((v) => {
                const params = pools_2.orcaDevnetPoolConfigs[v];
                const tokens = Object.keys(params.tokens);
                return [
                    tokens[0].toString() + tokens[1].toString(),
                    params,
                ];
            }));
        }
        else if (cluster == "mainnet-beta") {
            tokenPairToOrcaLegacyPool = Object.fromEntries(Object.values(sdk_1.OrcaPoolConfig).map((v) => {
                const params = pools_1.orcaPoolConfigs[v];
                const tokens = Object.keys(params.tokens);
                return [
                    tokens[0].toString() + tokens[1].toString(),
                    params,
                ];
            }));
        }
        else {
            throw new Error("Cluster ${cluster} not supported");
        }
        const params = tokenPairToOrcaLegacyPool[tokenPairSig];
        if (params == undefined) {
            throw new Error("Token pair not supported");
        }
        // TODO marketId to trading pair mapping
        const marketId = 0;
        const accounts = {
            marketId: marketId,
            programId: DEVNET_ORCA_TOKEN_SWAP_ID,
            swapProgram: params.address,
            swapAuthority: params.authority,
            poolTokenMint: params.poolTokenMint,
            feeAccount: params.feeAccount,
            tokenAccountA: tokenA,
            tokenAccountB: tokenB,
        };
        return new OrcaLegacySwap(accounts);
    }
    // This is used ONLY to create a mock orca swap for testing
    static initialize(provider, owner, // owner of the pool
    tokenA, // mint of token A
    tokenB, // mint of token B
    tokenOwnerA, // acct that can mint token A
    tokenOwnerB // acct that can mint token B
    ) {
        return __awaiter(this, void 0, void 0, function* () {
            const accounts = yield createMockSwap(provider, owner, tokenA, tokenB, tokenOwnerA, tokenOwnerB);
            return new OrcaLegacySwap(accounts);
        });
    }
}
exports.OrcaLegacySwap = OrcaLegacySwap;
const createAccount = (provider, space, owner) => __awaiter(void 0, void 0, void 0, function* () {
    const newAccount = web3_js_1.Keypair.generate();
    const createTx = new web3_js_1.Transaction().add(web3_js_1.SystemProgram.createAccount({
        fromPubkey: provider.wallet.publicKey,
        newAccountPubkey: newAccount.publicKey,
        programId: owner,
        lamports: yield provider.connection.getMinimumBalanceForRentExemption(space),
        space,
    }));
    yield provider.sendAndConfirm(createTx, [newAccount]);
    return newAccount;
});
// constants: https://github.com/orca-so/typescript-sdk/blob/main/src/public/utils/constants.ts
const DEVNET_ORCA_TOKEN_SWAP_ID = new web3_js_1.PublicKey("3xQ8SWv2GaFXXpHZNqkXsdxq5DZciHBz6ZFoPPfbFd7U");
const ORCA_TOKEN_SWAP_ACCOUNT_LEN = 324;
const initOrcaSwapIxDataLayout = BufferLayout.struct([
    BufferLayout.u8("instruction"),
    BufferLayout.u8("nonce"),
    BufferLayout.nu64("tradeFeeNumerator"),
    BufferLayout.nu64("tradeFeeDenominator"),
    BufferLayout.nu64("ownerTradeFeeNumerator"),
    BufferLayout.nu64("ownerTradeFeeDenominator"),
    BufferLayout.nu64("ownerWithdrawFeeNumerator"),
    BufferLayout.nu64("ownerWithdrawFeeDenominator"),
    BufferLayout.nu64("hostFeeNumerator"),
    BufferLayout.nu64("hostFeeDenominator"),
    BufferLayout.u8("curveType"),
    BufferLayout.blob(32, "curveParameters"),
]);
function createMockSwap(provider, owner, // owner of the pool
tokenA, // mint of token A
tokenB, // mint of token B
tokenOwnerA, // acct that can mint token A
tokenOwnerB // acct that can mint token B
) {
    return __awaiter(this, void 0, void 0, function* () {
        // This step will create the swap program account, which is used to store states of the pool
        const swapProgram = yield createAccount(provider, ORCA_TOKEN_SWAP_ACCOUNT_LEN, DEVNET_ORCA_TOKEN_SWAP_ID);
        const [authority, bump] = yield web3_js_1.PublicKey.findProgramAddress([swapProgram.publicKey.toBuffer()], DEVNET_ORCA_TOKEN_SWAP_ID);
        // This step will create the pool's native LP token
        const poolTokenMint = yield spl_token_1.Token.createMint(provider.connection, owner, authority, null, 6, spl_token_1.TOKEN_PROGRAM_ID);
        // This step will create the pool's fee account
        const feeAccount = yield poolTokenMint.createAssociatedTokenAccount(poolTokenMint.publicKey);
        // This step will mint some mock tokens to be swaped for testing purposes
        const tokenSupplyA = (yield tokenA.getOrCreateAssociatedAccountInfo(tokenOwnerA.publicKey)).address;
        yield tokenA.mintTo(tokenSupplyA, tokenOwnerA, [], 1000000000);
        const tokenSupplyB = (yield tokenB.getOrCreateAssociatedAccountInfo(tokenOwnerB.publicKey)).address;
        yield tokenB.mintTo(tokenSupplyB, tokenOwnerB, [], 2000000000);
        // This step will transfer the ownership of token A & B accounts to the pool.
        yield tokenA.setAuthority(tokenSupplyA, authority, "AccountOwner", tokenOwnerA.publicKey, []);
        yield tokenB.setAuthority(tokenSupplyB, authority, "AccountOwner", tokenOwnerB.publicKey, []);
        // define trading fees
        const tradeFeeNumerator = 25;
        const tradeFeeDenominator = 10000;
        const ownerFeeNumerator = 5;
        const ownerFeeDenominator = 10000;
        const ixData = Buffer.alloc(99);
        initOrcaSwapIxDataLayout.encode({
            instruction: 0x00,
            nonce: bump,
            tradeFeeNumerator: tradeFeeNumerator,
            tradeFeeDenominator: tradeFeeDenominator,
            ownerTradeFeeNumerator: ownerFeeNumerator,
            ownerTradeFeeDenominator: ownerFeeDenominator,
            ownerWithdrawFeeNumerator: 0,
            ownerWithdrawFeeDenominator: 0,
            hostFeeNumerator: 0,
            hostFeeDenominator: 0,
            curveType: 0,
            curveParameters: Buffer.alloc(32),
        }, ixData);
        const keys = [
            { pubkey: swapProgram.publicKey, isSigner: false, isWritable: true },
            { pubkey: authority, isSigner: false, isWritable: false },
            { pubkey: tokenSupplyA, isSigner: false, isWritable: false },
            { pubkey: tokenSupplyB, isSigner: false, isWritable: false },
            { pubkey: poolTokenMint.publicKey, isSigner: false, isWritable: true },
            { pubkey: feeAccount, isSigner: false, isWritable: true },
            { pubkey: feeAccount, isSigner: false, isWritable: true },
            { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
        ];
        const tx = new web3_js_1.Transaction().add(new web3_js_1.TransactionInstruction({
            keys,
            programId: DEVNET_ORCA_TOKEN_SWAP_ID,
            data: ixData,
        }));
        yield provider.sendAndConfirm(tx, [owner]);
        const orcaAccounts = {
            marketId: 0,
            programId: DEVNET_ORCA_TOKEN_SWAP_ID,
            swapProgram: swapProgram.publicKey,
            swapAuthority: authority,
            poolTokenMint: poolTokenMint.publicKey,
            feeAccount: feeAccount,
            tokenAccountA: tokenSupplyA,
            tokenAccountB: tokenSupplyB,
        };
        return orcaAccounts;
    });
}
//# sourceMappingURL=orca_legacy.js.map